import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { formatDate } from "../../../utils/date-utils";

import * as campaignActions from "../campaign.actions";
import { getAllCampaigns } from "../../campaign/campaign.selectors";

import Table from "../../common/components/Table";
import { ContentBlock } from "../../pages/components";
import { Localize } from "../../../locale/localization";
import Button from "../../../ui/button/Button";
import { sortTableAndHead } from "../../../utils/content-utils";
import TableHeader from "../../common/components/TableHeader";

class CampaignAdminBlock extends Component {
  state = {
    sortedData: [],
    tableHead: [
      { name: "startDate", uiName: Localize("starts") },
      { name: "endDate", uiName: Localize("ends") },
      { name: "channelName", uiName: Localize("campaign.partner") },
      { name: "prizeShopEndDate", uiName: Localize("campaign.shop.endDate") },
      { name: "bonusPercentage", uiName: Localize("campaign.bonus") }
    ]
  };

  componentWillMount() {
    const { getCampaigns } = this.props;
    getCampaigns();
  }

  componentWillReceiveProps(nextProps) {
    this.updateSortData(nextProps.campaigns);
  }

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        sortedData: content ? content : []
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(headItem, this.state.tableHead, this.state.sortedData);
    this.setState(
      Object.assign({}, this.state, {
        sortedData: sorted.data,
        tableHead: sorted.head
      })
    );
  };

  renderTableHeader = () => {
    return (
      <TableHeader
        items={this.state.tableHead}
        onSort={this.sortTable}
        sortable={this.state.sortedData.length > 1}
      />
    );
  };

  renderHeaderActions() {
    return (
      <NavLink to="/admin/campaigns/add">
        <Button icon="#plus">
          {Localize("campaign.create")}
        </Button>
      </NavLink>
    );
  }

  renderItem = (campaign, index) => {
    const { startDate, endDate, prizeShopEndDate, bonusPercentage, channel } = campaign;
    const channelName = channel && channel.name ? channel.name : "";

    return (
      <tr key={index}>
        <td>{formatDate(startDate)}</td>
        <td>{formatDate(endDate)}</td>
        <td>{channelName}</td>
        <td>{formatDate(prizeShopEndDate)}</td>
        <td>{bonusPercentage}</td>
      </tr>
    );
  };

  render() {
    const campaigns = this.state.sortedData;

    return (
      <ContentBlock title={Localize("campaign-time")} renderActions={this.renderHeaderActions}>
        <Table
          items={campaigns}
          renderHeader={this.renderTableHeader}
          renderItem={this.renderItem}
          widths={["14.5%", "14.5%", "28%", "28%", "15%"]}
        />
        <footer>
          <NavLink style={{float:'right'}} to="/admin/campaigns">{Localize("campaigns.edit")}</NavLink>
        </footer>
      </ContentBlock>
      );
  }
}

const mapStateToProps = state => {
  const campaigns = getAllCampaigns(state);
  return {
    campaigns
  };
};

const ConnectedCampaignAdminBlock = connect(mapStateToProps, campaignActions)(CampaignAdminBlock);

export default ConnectedCampaignAdminBlock;



// WEBPACK FOOTER //
// ./src/modules/campaign/components/CampaignAdminBlock.js